/**
 * Approved German copy for the Blog index page. Loaded after the earlier
 * dictionaries so it overrides older machine-generated blog wording.
 */
const dict: Record<string, string> = {
  // Hero
  Blog: "Blog",
  "Partner marketing,": "Partnermarketing,",
  "explained by the people running it.": "erklärt von denen, die es täglich umsetzen.",
  "Insights, case studies and practical guides on affiliate marketing, creator partnerships, marketplace promotion and external traffic.":
    "Insights, Case Studies und praktische Leitfäden zu Affiliate-Marketing, Creator-Partnerschaften, Marketplace-Promotion und externem Traffic.",
  "Search articles": "Artikel durchsuchen",

  // Articles list
  "All articles": "Alle Artikel",
  article: "Artikel",
  articles: "Artikel",
  "All topics": "Alle Themen",
  "More topics": "Weitere Themen",

  // Newsletter
  Newsletter: "Newsletter",
  "New articles, straight to your inbox": "Neue Artikel direkt in Ihr Postfach",
  "A short round-up of new Catuik articles, case studies and practical partner-marketing guides. No spam, unsubscribe at any time.":
    "Eine kurze Übersicht über neue Catuik-Artikel, Case Studies und praktische Leitfäden zum Partnermarketing. Kein Spam, jederzeit abbestellbar.",
  Email: "E-Mail",
  Subscribe: "Abonnieren",
};

export default dict;
